import {AmountStatus} from "./race-registration/amount-status";
import {RegistrationStatus} from "./race-registration/registration-status";

export class ConfirmPayment {

    constructor(public registrationId?: number,
                public competitorId?: number,
                public amountStatus?: AmountStatus,
                public registrationStatus?: RegistrationStatus,
                public note?: string) {
    }

}